import {useMutation} from "@tanstack/react-query";

import {addServiceDescriptionMutationOptions} from "./add-service-description.mutation-options";

export function useAddServiceDescription(id: string) {
  return useMutation(addServiceDescriptionMutationOptions(id));
}
